import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "title-bar mb-2" }
const _hoisted_4 = { class: "row gx-2 align-items-center" }
const _hoisted_5 = { class: "col d-flex align-items-center gap-3" }
const _hoisted_6 = { class: "d-flex align-items-center gap-1" }
const _hoisted_7 = { class: "title-label" }
const _hoisted_8 = { class: "d-flex align-items-center gap-1" }
const _hoisted_9 = { class: "title-label" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex-grow-1" }
const _hoisted_15 = { class: "table table-hover table-v2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"80px"} }, " ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"20px"} }, " ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"40px"} }, " ", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  style: {"width":"30px"},
  class: "low-padding"
}, null, -1)
const _hoisted_22 = {
  style: {"width":"20px"},
  class: "h-100 background-gray align-middle low-padding"
}
const _hoisted_23 = { class: "d-flex justify-content-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_28 = ["onMouseenter", "src"]
const _hoisted_29 = {
  style: {"width":"30px"},
  class: "h-100 align-middle low-padding"
}
const _hoisted_30 = { class: "d-flex justify-content-end" }
const _hoisted_31 = {
  style: {"width":"20px"},
  class: "h-100 background-gray align-middle low-padding"
}
const _hoisted_32 = { class: "d-flex justify-content-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_34 = { class: "align-middle" }
const _hoisted_35 = { class: "align-middle" }
const _hoisted_36 = { class: "align-middle" }
const _hoisted_37 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!
  const _component_InputRadio = _resolveComponent("InputRadio")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_InputCheckboxMultiSelect = _resolveComponent("InputCheckboxMultiSelect")!
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('showPhoto')), 1),
                _createVNode(_component_InputCheckbox, {
                  "model-value": _ctx.checkedCheckbox,
                  errors: {},
                  name: "checkedCheckbox",
                  class: "gray-checkbox"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('mainPhoto')), 1),
                _createVNode(_component_InputRadio, {
                  id: "demoRadioButton",
                  name: "checkedRadioButton",
                  errors: {},
                  "model-value": _ctx.checkedRadioButton,
                  value: "checked"
                }, null, 8, ["model-value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.pageUI.isReady())
                  ? (_openBlock(), _createBlock(_component_base_modal_button, {
                      key: 0,
                      class: "btn btn-hover icon-link uppercase",
                      "modal-id": _ctx.modalId,
                      onClick: _ctx.onBeforeModalOpened
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                      ]),
                      _: 1
                    }, 8, ["modal-id", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GenericFormWrapper, {
      pageUI: _ctx.pageUI,
      submitData: _ctx.submitData
    }, _createSlots({
      content: _withCtx(({ errors }) => [
        _withDirectives(_createElementVNode("img", {
          src: _ctx.hooveringOverImage,
          alt: "preview",
          class: "hover-image shadow",
          style: _normalizeStyle(_ctx.hoverImageStyle)
        }, null, 12, _hoisted_13), [
          [_vShow, _ctx.hooveringOverImage]
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (language) => {
                  return (_openBlock(), _createElementBlock("th", {
                    colspan: "2",
                    key: language
                  }, _toDisplayString(language.toUpperCase()), 1))
                }), 128)),
                _hoisted_17,
                _createElementVNode("th", {
                  style: _normalizeStyle(`width: calc(60% - ${_ctx.deductPixelsForFileColumn}px;`)
                }, _toDisplayString(_ctx.$t('file')), 5),
                _createElementVNode("th", {
                  style: _normalizeStyle(`width: calc(40% - ${_ctx.deductPixelsForSourceColumn}px;`)
                }, _toDisplayString(_ctx.$t('source')), 5),
                _hoisted_18
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.showPlaceholderPhoto)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsHovering(_ctx.placeHolderUrl, $event))),
                        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setIsHovering(null, $event))),
                        src: _ctx.placeHolderUrl,
                        alt: "",
                        style: {"width":"80px","height":"auto"}
                      }, null, 40, _hoisted_20)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (language) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: language }, [
                        _hoisted_21,
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_InputRadio, {
                              id: `PlaceHolder_Main_${language}`,
                              name: `Main_Image_${language}`,
                              errors: errors,
                              modelValue: _ctx.getLanguageSettings(language)!.main_image_original_filename,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.getLanguageSettings(language)!.main_image_original_filename) = $event),
                              value: _ctx.PLACE_HOLDER_VALUE,
                              class: "paddingless-input",
                              onChange: () => _ctx.selectPlaceholderForLanguage(language)
                            }, null, 8, ["id", "name", "errors", "modelValue", "onUpdate:modelValue", "value", "onChange"])
                          ])
                        ])
                      ], 64))
                    }), 128)),
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productImages!.images, (image) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: image.url
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("img", {
                      onMouseenter: ($event: any) => (_ctx.setIsHovering(image.url, $event)),
                      onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setIsHovering(null, $event))),
                      src: image.url,
                      alt: "",
                      style: {"width":"80px","height":"auto"}
                    }, null, 40, _hoisted_28)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (language) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: language }, [
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_InputCheckboxMultiSelect, {
                            modelValue: _ctx.getLanguageSettings(language)!.shown_images_original_filenames,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.getLanguageSettings(language)!.shown_images_original_filenames) = $event),
                            onChange: () => _ctx.changeShowImageForLanguage(language, image.original_filename),
                            value: image.original_filename,
                            name: `Show_Image_${language}`,
                            errors: errors,
                            class: "paddingless-input gray-checkbox"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "value", "name", "errors"])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_InputRadio, {
                            id: `${image.original_filename}_Main_${language}`,
                            name: `Main_Image_${language}`,
                            errors: errors,
                            modelValue: _ctx.getLanguageSettings(language)!.main_image_original_filename,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.getLanguageSettings(language)!.main_image_original_filename) = $event),
                            value: image.original_filename,
                            class: "paddingless-input",
                            onChange: () => _ctx.selectMainImageForLanguage(language, image.original_filename)
                          }, null, 8, ["id", "name", "errors", "modelValue", "onUpdate:modelValue", "value", "onChange"])
                        ])
                      ])
                    ], 64))
                  }), 128)),
                  _hoisted_33,
                  _createElementVNode("td", _hoisted_34, _toDisplayString(image.original_filename), 1),
                  _createElementVNode("td", _hoisted_35, _toDisplayString(image.source.description), 1),
                  _createElementVNode("td", _hoisted_36, [
                    (image.source.code === 'CUSTOMER')
                      ? (_openBlock(), _createBlock(_component_BaseDeleteButton, {
                          key: 0,
                          deleteData: () => _ctx.deleteItemWithKey(image.original_filename),
                          pageUI: _ctx.pageUI
                        }, null, 8, ["deleteData", "pageUI"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 2
    }, [
      (_ctx.addCloseOffCanvasButton)
        ? {
            name: "buttons",
            fn: _withCtx(() => [
              _createVNode(_component_base_offcanvas_button_close, {
                ref: "closeButton",
                class: "ms-3 btn btn-light"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                ]),
                _: 1
              }, 512)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["pageUI", "submitData"]),
    _createVNode(_component_base_modal, {
      "modal-id": _ctx.modalId,
      "dialog-classes": "modal-sm",
      title: _ctx.$t('addProductImage'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_GenericFormWrapper, {
          pageUI: _ctx.uploadImageUI,
          submitData: _ctx.submitAddProductImage
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_InputImage, {
                "onUpdate:modelValue": [
                  _ctx.imageUploaded,
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.documentKey) = $event))
                ],
                onImageCleared: _ctx.imageCleared,
                modelValue: _ctx.documentKey,
                module: _ctx.DpModuleEnum.PP3,
                typeCode: "PRODUCT_IMG",
                useSignedUrl: "",
                maxFileSize: 2
              }, null, 8, ["onUpdate:modelValue", "onImageCleared", "modelValue", "module"])
            ])
          ]),
          _: 1
        }, 8, ["pageUI", "submitData"])
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}